import React from 'react'
import {
    Toolbar,
    Button,
    makeStyles,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core'
import { useGlobalStyles } from '../../App'

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        padding: theme.spacing(2),
    },
    enhancedTableToolbar: {
        width: '100%',

        '& .MuiToolbar-gutters': {
            paddingRight: 16,
        },
    },
    toolBar: {
        float: 'right',
    },
    tableSection: {
        marginTop: 25,
    },
    formControl: {
        minWidth: 120,
        maxWidth: 300,
    },
}))

const headCells = [
    { id: 'name', label: 'Name' },
    { id: 'description', label: 'Description' },
    { id: 'expiryDate', label: 'Expiry Date' },
    { id: 'issuer', label: 'Issuer' },
    { id: 'thumbprint', label: 'Thumbprint' },
]

const tableData = [
    {
        name: 'Cheerios',
        description: 'Some Description',
        expiryDate: '01/01/2000 11:22:33',
        issuer: 'AdviserPlus',
        thumbprint: '10001111',
    },
    {
        name: 'Dave',
        description: 'Description',
        expiryDate: '01/02/2000 11:22:33',
        issuer: 'Google',
        thumbprint: '2000002',
    },
]

const Certificates = () => {
    const classes = useStyles()
    const globalClasses = useGlobalStyles()

    const EnhancedTableToolbar = () => {
        return (
            <div className={classes.enhancedTableToolbar}>
                <Toolbar></Toolbar>
            </div>
        )
    }

    const getTableContent = () => {
        return tableData.map(row => (
            <TableRow>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.expiryDate}</TableCell>
                <TableCell>{row.issuer}</TableCell>
                <TableCell>{row.thumbprint}</TableCell>
                <TableCell align='right'>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {}}>
                        Delete
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={() => {}}>
                        Edit
                    </Button>
                </TableCell>
            </TableRow>
        ))
    }

    return (
        <Paper className={classes.tableWrapper}>
            <div className={classes.tableSection}>
                <EnhancedTableToolbar />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby='tableTitle'
                        aria-label='enhanced table'>
                        <TableHead className={globalClasses.tableHeader}>
                            <TableRow>
                                {headCells.map((headCell, index) => (
                                    <TableCell key={'head-cell-' + index}>
                                        {headCell.label}
                                    </TableCell>
                                ))}
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>{getTableContent()}</TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Paper>
    )
}

export default Certificates
